import { GenericTableFactory } from "@/components/_Shared/Table/Classes/Factory"
import { Header } from "@/components/misc"
import { LogOut } from "@/components/NavBar/UI/Components/LogOut"

/**
 * Shows the client their list of projects
 * 
 * Ensure that the user is authenticated and is a client
 *  as well as they use an exclusive API to get their projects
 * 
 */
export function ClientProject() {
    const table = GenericTableFactory.createClientProjectTable()

    return (
        <>
            <Header />
            <div className="p-5">
                <h1>Client Projects</h1>
                <div className="flex flex-col justify-between">
                    {table.RenderTable()}
                </div>
                
                <LogOut />
            </div>
        </>
    )
}
